module.exports = __webpack_public_path__ + "static/media/17UN-Women5.3d3c1f15.jpg";